// @flow

import styled, { css } from 'styled-components';
import {
  grid, gridTemplateColumns, gridTemplateRows, gridArea,
} from '../../../helpers/gridHelpers';
import {
  ContentWrapper,
  Title as DefaultTitle,
  Description as DefaultDescription,
} from '../components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';

export const Container = styled<any, Theme>('section')`
  ${grid()}
  ${gridTemplateColumns('1fr 8.25rem 1fr')}
  ${gridTemplateRows('3.75rem 4.5rem 1fr auto')}
  height: 100%;

  ${media.lg(css`
    ${gridTemplateColumns('1fr 7.5rem 1fr')}
    ${gridTemplateRows('3.25rem 4.25rem 1fr auto')}
  `)};
`;

export const Icon = styled<any, Theme>('header')`
  ${gridArea('1 / 1 / 3 / 4')}
  height: calc(100% - 1rem);
  width: calc(100% - 1rem);

  > div {
    display: flex;
    height: 100%;
    justify-content: center;
    max-height: 100%;
    width: 100%;

    section {
      width: 100%;
    }

    svg {
      height: 100%;
      max-width: 100%;
    }
  }
`;

export const Content = styled<typeof ContentWrapper, Theme>(ContentWrapper)`
  ${gridArea('3 / 1 / 4 / 4')}
  padding-top: 1rem;
`;

export const Title = styled<typeof DefaultTitle, Theme>(DefaultTitle)`
  padding-bottom: .75rem;
  text-align: center;
`;

export const Description = styled<typeof DefaultDescription, Theme>(DefaultDescription)`
  text-align: center;
`;

export const ButtonWrapper = styled<any, Theme>('footer')`
  ${gridArea('4 / 1 / 5 / 4')}
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 0;
`;

export default null;
